import { GuardUtils } from './../GuardUtils';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompleteGuard implements CanActivate {
  constructor(private guardUtils: GuardUtils, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.guardUtils.isAdmin()) {
      return true;
    }

    if (this.guardUtils.isAuthenticated()) {
      if (this.guardUtils.isCompleted()) {
        return true;
      }
    }

    return this.router.parseUrl(route.data.redirectTo);
  }
}
